export default __webpack_public_path__ + "static/media/calendar-clock.ad300bd0.svg";